// ─────────────────────────────────────────────────────────────────
// Glass-i — Glass Concepts API client (Stage 6B.8A-3I).
//
// Thin axios wrappers around /api/erp/masters/glass-concepts/*.
// Mirrors the itemsApi pattern: same envelope unwrap + camelCase
// query shape. No grid-field translator — the gallery / table views
// drive their own pagination locally.
// ─────────────────────────────────────────────────────────────────

import client from '../../../../api/client';

const BASE = '/api/erp/masters/glass-concepts';

function unwrap(resp) {
  return resp && resp.data && resp.data.data !== undefined
    ? resp.data.data
    : resp && resp.data;
}

export const glassConceptsApi = {
  list:      (params = {}) =>
    client.get(BASE, { params }).then(unwrap),
  get:       (id) =>
    client.get(`${BASE}/${encodeURIComponent(id)}`).then(unwrap),
  create:    (payload) =>
    client.post(BASE, payload).then(unwrap),
  update:    (id, payload) =>
    client.put(`${BASE}/${encodeURIComponent(id)}`, payload).then(unwrap),
  remove:    (id) =>
    client.delete(`${BASE}/${encodeURIComponent(id)}`).then(unwrap),
  duplicate: (id) =>
    client.post(`${BASE}/${encodeURIComponent(id)}/duplicate`, {}).then(unwrap),
  buildQuotationPayload: (id, payload) =>
    client.post(`${BASE}/${encodeURIComponent(id)}/build-quotation-payload`, payload)
      .then(unwrap)
};

// User-facing enum labels — keep in sync with backend constants.
export const CONCEPT_TYPE_OPTIONS = [
  { value: 'patch_door',         label: 'Patch Fitting Door' },
  { value: 'floor_spring_door',  label: 'Floor Spring Door' },
  { value: 'sliding_door',       label: 'Sliding / Partition Door' },
  { value: 'shower_cubicle',     label: 'Shower Cubicle' },
  { value: 'partition',          label: 'Partition' },
  { value: 'fixed_panel',        label: 'Fixed Panel' },
  { value: 'double_door',        label: 'Double Door' },
  { value: 'entrance_front',     label: 'Entrance / Storefront' },
  { value: 'glass_concept',      label: 'Glass Concept (Generic)' },
  { value: 'other',              label: 'Other' }
];

// Stage 6B.8A-3J — curated fabrication / cutout vocabulary. Mirrors
// FABRICATION_OPTIONS on the backend. The Fabrication column in the
// concept editor uses an AutoComplete so operators can pick from this
// list OR free-type a brand-specific cutout up to 120 chars.
export const FABRICATION_OPTIONS = [
  'No Cutout',
  'Top Patch',
  'Bottom Patch',
  'Top + Bottom Patch',
  'Corner Lock Cutout',
  'Handle Hole',
  'Floor Spring Cutout',
  'W/G Hinge Cutout',
  'W/G Bracket Cutout',
  'G/G Bracket Cutout',
  'Pipe Connector Hole',
  'Shower Handle Hole',
  'Custom Fabrication'
];

export const PANEL_ROLE_OPTIONS = [
  { value: 'door',             label: 'Door' },
  { value: 'fixed_panel',      label: 'Fixed Panel' },
  { value: 'side_panel',       label: 'Side Panel' },
  { value: 'top_panel',        label: 'Top Panel' },
  { value: 'partition_panel',  label: 'Partition Panel' },
  { value: 'return_panel',     label: 'Return Panel' },
  { value: 'shelf',            label: 'Shelf' },
  { value: 'other',            label: 'Other' }
];

export default glassConceptsApi;
